import { provideAbpCore, withOptions } from '@abp/ng.core';
import { provideAccountAdminConfig } from '@volo/abp.ng.account/admin/config';
import { withValidationBluePrint, provideAbpThemeShared, withHttpErrorConfig, CUSTOM_ERROR_HANDLERS } from '@abp/ng.theme.shared';
import { provideCommercialUiConfig } from '@volo/abp.commercial.ng.ui/config';
import { provideIdentityConfig } from '@volo/abp.ng.identity/config';
import { provideAbpOAuth } from '@abp/ng.oauth';
import { provideSettingManagementConfig } from '@abp/ng.setting-management/config';
import { provideFeatureManagementConfig } from '@abp/ng.feature-management';
import { provideAccountPublicConfig } from '@volo/abp.ng.account/public/config';
import { provideAuditLoggingConfig } from '@volo/abp.ng.audit-logging/config';
import { provideLanguageManagementConfig } from '@volo/abp.ng.language-management/config';
import { registerLocale } from '@volo/abp.ng.language-management/locale';
import { provideSaasConfig } from '@volo/abp.ng.saas/config';
import { ApplicationConfig, inject, provideAppInitializer, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, TitleStrategy } from '@angular/router';
import { environment } from '../environments/environment';
import { APP_ROUTES } from './app.routes';
import { APP_ROUTE_PROVIDER } from './route.provider';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory, ZnErrorHandler } from '@zendra/shared';
import { FaroInitializerService } from './shared/observability/faro-initializer-service';
import { AppVersionService } from './shared/services/app-version-service';
import { ErrorHandlerService } from './shared/services/error-handler.service';
import { OrchestratorConfigModule } from 'orchestrator/config';
import { CustomTitleStrategy } from './shared/custom-title-strategy';
import { HttpErrorComponent, provideThemeLeptonX } from '@volosoft/abp.ng.theme.lepton-x';
import { provideSideMenuLayout } from '@volosoft/abp.ng.theme.lepton-x/layouts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(APP_ROUTES),
    APP_ROUTE_PROVIDER,
    provideHttpClient(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    importProvidersFrom(AngularSlickgridModule.forRoot()),
    {
      provide: CUSTOM_ERROR_HANDLERS,
      useExisting: ZnErrorHandler,
      multi: true,
    },
    provideAppInitializer(() => {
      inject(FaroInitializerService);
    }),
    FaroInitializerService,
    AppVersionService,
    ErrorHandlerService,
    provideAnimations(),
    provideAbpCore(
      withOptions({
        environment,
        registerLocaleFn: registerLocale(),
        localizations: [
            {
                culture: 'en',
                resources: [
                    {
                        resourceName: 'LanguageService',
                        texts: {
                            "Menu:Home": "Home",
                            "Login": "Login",
                            "Menu:CBD":"CBD",
                            "Menu:Dashboard": "Dashboard",
                            "LongWelcomeMessage": "Welcome to the application. This is a startup project based on the ABP framework. For more information visit",
                            "Welcome": "Welcome",
                        }
                    }
                ]
            }
        ]
      }),
    ),
    provideAbpOAuth(),
    provideIdentityConfig(),
    provideSettingManagementConfig(),
    provideFeatureManagementConfig(),
    provideAccountAdminConfig(),
    provideAccountPublicConfig(),
    provideCommercialUiConfig(),
    provideThemeLeptonX(),
		provideSideMenuLayout(),
    provideAbpThemeShared(
      withHttpErrorConfig({
        errorScreen: {
          component: HttpErrorComponent,
          forWhichErrors: [401, 403, 404, 500],
          hideCloseIcon: true,
        },
      }),
      withValidationBluePrint({
        wrongPassword: 'Please choose 1q2w3E*',
      }),
    ),
    provideLanguageManagementConfig(),
    provideSaasConfig(),
    provideAuditLoggingConfig(), importProvidersFrom(OrchestratorConfigModule.forRoot()),
    { provide: TitleStrategy, useClass: CustomTitleStrategy }
  ]
}
